// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__167Li","itemTitle":"ClientEmergencyInfo_itemTitle__aDI1O","itemText":"ClientEmergencyInfo_itemText__2tI59"};